export default __webpack_public_path__ + "static/background-3cd8f67301c411040a6da77ca16191f8.webp";